/**
 * The Player class acts as the view object for the player.
 */
const tbs_model_vo_DemoTabTwo = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_DemoTabTwo.prototype = {
    /* The view object name */
    name: 'tabTwoData',
    /* The view object instance */
    view: {
        get: [
            {
                name: 'firstItem',
                baseUrl: 'https://cpb.bingouai.com',
                apiPrefix: '/api/res',
                apiSuffix: 'accessKey=baseball-stats',
                service: '/games/player',
                query: {
                },
                basePath: 'data',
                rule: {
                    label: 'name'
                }
            },
            {
                name: 'secondItem',
                baseUrl: 'https://cpb.bingouai.com',
                apiPrefix: '/api/res',
                apiSuffix: 'accessKey=baseball-stats',
                service: '/teams/player',
                query: {
                },
                basePath: 'data',
                rule: {
                    label: 'name'
                }
            }
        ],
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
}

module.exports = tbs_model_vo_DemoTabTwo